var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"fade-page"}},[(_vm.isLobbyPage)?_c('div',{staticClass:"nav-sections-wrap container",attrs:{"id":"nav-sections"}},[_c('NavSectionsInner')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }